<template>
  <div class="bg">
    <div class="content">
      <div class="title">
        <div class="title-main">
          <div class="title-main-CN">运动员排行榜</div>
          <div class="title-main-EN">Athele Rankings</div>
        </div>
        <div class="title-sub">More</div>
      </div>
      <div class="main">
        <div class="first">
          <div class="first-left" >
            <div class="left-topOne price">1</div>
            <div class="left-bottom">
              <div class="baseInfo">
                <div class="player-name" >{{firstPerson.name}}</div>
                <div class="other-info">
                  <div class="org">{{firstPerson.unitName}}</div>
                  <div class="score">
                    <div class="score-txt">积分</div>
                    <div class="score-num">{{firstPerson.score}}</div>
                  </div>
                </div>
              </div>
              <div class="matchInfo">
                <div class="counts">
                  <div class="counts-total">
                    <div class="counts-total-txt">场次</div>
                    <div class="counts-total-num">{{firstPerson.matchNum}}</div>
                  </div>
                  <div class="counts-line">
                     <div class="counts-percent" :style="{width:getPercent('TOTAL')+'%'}"></div>
                  </div>
                </div>
                <div class="counts">
                  <div class="counts-total">
                    <div class="counts-total-txt">胜场</div>
                    <div class="counts-total-num">{{firstPerson.matchNum}}</div>
                  </div>
                  <div class="counts-line">
                     <div class="counts-percent" :style="{width:getPercent()+'%'}"></div>
                  </div>
                </div>
                <div class="counts">
                  <div class="counts-total">
                    <div class="counts-total-txt">胜率</div>
                    <div class="counts-total-num">{{firstPerson.matchNum}}</div>
                  </div>
                  <div class="counts-line">
                    <div class="counts-percent" >
                       <div class="counts-percent" :style="{width:getPercent()+'%'}"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="first-right">
            <div class="tri3"></div>
            <img class="head-img" :src="firstPerson.image " alt="" >
          </div>
        </div>
        <div class="other">
          <div class="other-player" v-for="(item,index) in player" :key="item.image">
            <div class="other-rank">
              <div class="left-top"></div>
              <div class="ranking">{{index + 2}}</div>
            </div>
            <div class="other-name">{{item.name}}</div>
            <div class="other-score">
              <div class="right-top"></div>
              <div class="scores">{{item.score}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      info: {},
      player: [],
      // firstPerson: null,
      firstPerson: {
        areaName: '山西省',
        bronze: 0,
        cardId: 771,
        drawNum: 0,
        five: 0,
        gold: 1,
        image: 'https://static.daoba.com//183100150798.png',
        lostNum: 1,
        matchNum: 0,
        name: '虚位以待',
        score: 0,
        silver: 0,
        unitName: '',
        winNum: 4
      }
    }
  },
  created () {
    window.scrollTo(0, 0)
    this.loadData()
  },
  methods: {
    getPercent (e) {
      if (e !== 'TOTAL') {
        let total = Number(this.firstPerson.matchNum)
        let win = Number(this.firstPerson.winNum)
        let winPercent = (win / total * 100).toFixed(2)
        // console.log('winPercent', winPercent)
        return winPercent
      } else {
        return 100
      }
    },
    loadData () {
      let param = {
        programId: this.$route.query.programId,
        province: -1,
        year: -1,
        name: -1,
        // type: -1,
        pageNum: 1,
        pageSize: 10 // 此处只展示8条数据
      }
      this.$api.match.getPlayRank(param).then(res => {
        if (res.status === 0) {
          if (res.data.length !== 0) {
            this.firstPerson = res.data.slice(0, 1)[0]
            this.player = res.data.slice(1, 10)
          }
        }
      }).catch(err => {
        console.log('err', err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bg {
  width: 100%;
  background-color: #000;
  // padding-bottom: 500px;
}
.content {
  width: 100%;
  height: 700px;
  background-image: url(../../../assets/sportsLogo/playerRank_bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  // align-items: center;
  flex-direction: column;
  color: #fff;
  padding: 114px 0 120px 0;
}
.title{
  width: 1200px;
  height: 31px;
  // line-height: 31px;
  margin: 0 auto;
  margin-bottom: 35px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #FFF;
}
.main{
  width: 1200px;
  height: 500px;
  margin: 0 auto;
  // background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.title-main{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end !important;
}
.title-main-CN{
  font-size: 30px;
  margin-right: 5px;
}
.title-main-EN{
  font-size: 20px;
}
.title-sub{
  font-size: 14px;
}
.first{
  width: 660px;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: row;
}
.first-left{
  width: 60%;
  height:100%;
  // background-color: green;
}
.first-right{
  width: 40%;
  height: 100%;
  background-color: red;
  position: relative;
}
.left-topOne{
  width: 100%;
  height: 15%;
  // background-color: red;
}
.left-bottom{
  width: 100%;
  padding: 30px 70px;
  height: 85%;
  // background-color: blue;
}
.baseInfo{
  width: 100%;
}
.head-img{
  width: 100%;
  height: 100%;
  // position: absolute;
  // z-index: 2;
}
.matchInfo{
  width: 100%;
  margin-top: 30px;
}
.counts-total{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.counts-total-txt{
  color: #333;
}
.counts-total-num{
  color: #B01F24;
  font-weight: bold;
}
.counts-line{
  width: 100%;
  height: 3px;
  // background-color: #B01F24;
  background-color: #333333;
}
.counts-percent{
  height: 100%;
  background-color: #B01F24;
}
.counts{
  width: 100%;
  margin-bottom: 18px;
}
.player-name{
  width: 100%;
  font-size:23px;
  color: #000;
  letter-spacing: 30px;
}
.other-info{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #333;
}
.score{
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.score-num{
  margin-left: 8px;
  color: #B01F24;
   font-weight: bold;
}
.other{
  width: 500px;
  height: 100%;
  // background-color: green;
  display: flex;
  flex-direction: column;
}
.other-player{
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.8);
  margin-bottom: 5px;
}
.other-rank{
  flex: 1;
  height: 100%;
  text-align: center;
  position: relative;
}
.other-name{
  flex: 5;
  height: 100%;
  text-align: left;
  padding-left: 30px;
  color: #fffefe;
  font-size: 20px;
  background-color: rgba($color: #333, $alpha: 0.8);
  display: flex;
  align-items: center;
  // font-weight: bold;
}
.other-score{
  flex: 2;
  height: 100%;
  text-align: center;
  position: relative;
}
.left-top{
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  height: 0;
  width: calc(100% + 10px);
  border-top: 40px solid #b3b3b3;
  border-right: 10px solid transparent;
}
.right-top{
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  height: 0;
  width: calc(100% + 10px);
  border-bottom: 40px solid #b3b3b3;
  border-left: 10px solid transparent;
}
.ranking{
  position: absolute;
  z-index: 3;
  width: 60px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-weight: bold;
  font-size: 20px;
}
.scores{
  position: absolute;
  z-index: 3;
  width: 100px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
  align-items: center;
  color: #333;
  // font-weight: bold;
  font-size: 20px;
  text-align: center;
}
.trapezoid{
  position:relative;
  height: 80px;
  width: 360px;
  border-left:2px solid #c8c8c8;
  overflow:hidden;
  background-color: #333;
}
.trapezoid:before{
  content:'123';
  display:block;
  position:absolute;
  top:0;
  bottom:0;
  right:0;
  width: 360px;
  border:2px solid #c8c8c8;
  transform-origin:0 100%;
  transform:skewX(10deg);
}
.price {
    font-size: 30px;
    display: block;
    color: #fff;
    height: 0;
    width: 200px;
    line-height: 60px;
    padding-left: 5px;
    border-width: 0px 60px 60px 0px;
    border-style: none solid solid;
    border-color: transparent transparent #B01F24;
    text-align: center;
}
.tri3 {
  position: absolute;
  z-index: 3;
    width: 0;
    height: 0;
    border-color: transparent white; /*上下颜色 左右颜色*/
    border-width: 0 0 400px 80px;
    border-style: solid;
}

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/home/PlayerRanking.vue